import { useTranslation } from 'react-i18next'
import Select from '../Select'
import { RangePickerProps } from './RangePicker.types'
import { useRangePicker } from './RangePicker.utils'
import { config } from 'config'
import {
  Input,
  Container,
  Header,
  Main,
  Button,
  InputWrapper,
  Label,
  LabelWrapper,
  ErrorLabel,
} from './RangePicker.style'

const RangePicker = (props: RangePickerProps) => {
  const {
    label,
    placeholder,
    minPlaceholder,
    maxPlaceholder,
    fromLabel,
    toLabel,
    onClick,
    onClose,
    onlyPositive = true,
    id,
  } = props
  const {
    selectValue,
    onMinBlur,
    onMaxBlur,
    handleMaxChange,
    handleMinChange,
    minValue,
    maxValue,
    handleClear,
    maxRef,
    onMaxKeyDown,
    onMinKeyDown,
    isOpen,
    isError,
  } = useRangePicker(props)

  const { t } = useTranslation()
  const inputProps = onlyPositive ? { step: 0.01, min: 0 } : undefined
  return (
    <Select
      label={label}
      value={selectValue}
      placeholder={placeholder}
      onInputClick={onClick}
      renderNames={false}
      onClose={onClose}
      isOpen={isOpen}
      error={isError}
      id={id}
    >
      <Container>
        {handleClear && (
          <Header>
            <Button
              id={`${id}-clear-btn`}
              color="primary"
              onClick={handleClear}
            >
              {t('clear')}
            </Button>
          </Header>
        )}
        <Main>
          <InputWrapper>
            <Label color="primary">{fromLabel || t('from')}</Label>
            <LabelWrapper>
              <Input
                onBlur={onMinBlur}
                color="primary"
                variant="standard"
                placeholder={minPlaceholder || t('filters.minAmount')}
                onChange={handleMinChange}
                value={minValue}
                onKeyDown={onMinKeyDown}
                type="number"
                inputProps={inputProps}
                error={isError}
                id={`${id}-min`}
              />
              {isError && (
                <ErrorLabel error>
                  {t(`${config.errorNamespace}:filters.minAmount`)}
                </ErrorLabel>
              )}
            </LabelWrapper>
          </InputWrapper>
          <InputWrapper>
            <Label color="primary">{toLabel || t('to')}</Label>
            <LabelWrapper>
              <Input
                onBlur={onMaxBlur}
                color="primary"
                variant="standard"
                placeholder={maxPlaceholder || t('filters.maxAmount')}
                onChange={handleMaxChange}
                value={maxValue}
                onKeyDown={onMaxKeyDown}
                inputRef={maxRef}
                inputProps={inputProps}
                type="number"
                error={isError}
                id={`${id}-max`}
              />
              {isError && (
                <ErrorLabel error>
                  {t(`${config.errorNamespace}:filters.maxAmount`)}
                </ErrorLabel>
              )}
            </LabelWrapper>
          </InputWrapper>
        </Main>
      </Container>
    </Select>
  )
}

export default RangePicker
